<app-page-header>
  <span class="page-title"
    ><h3>Discussion</h3>
    <span>
      <a
        class="is-small is-link button i-want-highlight-this has-tooltip-left"
        id="createChat"
        data-tooltip="Add New Conversation"
        [routerLink]="['/chats/newchat']"
      >
        <i class="fa-solid fa-circle-plus"></i> </a></span
  ></span>
</app-page-header>
<div class="row">
  <div class="col-auto pe-1" [ngClass]="{ 'hide-listwrapper': viewChatList }">
    <div
      class="col second-level-menu conversation-group-list is-chat right-box-shadow"
    >
      <!-- <div class="menu-options level is-marginless display-flex">
      <div class="level-left">
        <div class="level-item">
          <div class="select is-small">
            <select [(ngModel)]="sortBy" (change)="getChatList(0)">
              <option value="name">Sort A to Z</option>
              <option value="time" selected>Sort by Recent</option>
            </select>
          </div>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <a class="button is-small" (click)="showSearchbox('open')">
            <i class="fa fa-search"></i>
          </a>


        </div>
      </div>
    </div> -->

      <div class="menu-options searchBox-pad display-flex">
        <div class="level-left">
          <div class="input-search-box">
            <div class="field">
              <p class="control has-icons-left has-icons-right">
                <input
                  class="input"
                  type="text"
                  placeholder="Search"
                  [(ngModel)]="search"
                  (keyup)="searchInList.next($event)"
                  placeholder="Search here..."
                />

                <a class="icon is-small is-left" title="Search">
                  <i class="fa fa-search"></i>
                </a>
                @if (search != '') {
                <span
                  class="icon is-small is-right search-return"
                  (click)="showSearchbox('close')"
                >
                  <i class="fa fa-times"></i>
                </span>
                }
                <span class="input-bar"></span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="tab-content">
          <div
            class="list-wrapper scroll-bar list-overflow scrollUserandGroup"
            appInfiniteScroll
            (reachedBottom)="onScrollDown()"
          >
            <ul>
              @for (user of chatList | sortByDate : listSortBy : true; track
              user; let ind = $index) {
              <li
                class="cursor-pointer pos-relative chat-list"
                routerLinkActive="active"
                [ngClass]="{ hideInactiveGroup: user.group_active === false }"
              >
                @if (user?.chat_type == 'user') {
                <div
                  class="columns is-gapless active display-flex"
                  [routerLink]="['/chats/singleuser', user.user_id]"
                  (click)="swichUser(user)"
                >
                  <div class="column is-one-quarter">
                    @if (!user.user_icon) {
                    <empty-uname
                      [userName]="user.full_name"
                      [liProfile]="true"
                      title="{{ user.status_name }}"
                    ></empty-uname>
                    } @if (user.user_icon) {
                    <img
                      [src]="profileUrl + user.user_icon"
                      alr=""
                      title="{{ user.status_name }}"
                    />
                    } @if (user.is_online) {
                    <span class="icon is-small">
                      @if (user.is_online) {
                      <i
                        class="fa fa-circle"
                        [ngClass]="{
                          'circle-grey': user.user_status === 0,
                          'circle-green': user.user_status === 1,
                          'circle-red': user.user_status === 2,
                          'circle-yellow': user.user_status === 3
                        }"
                      ></i>
                      }
                    </span>
                    } @if (!user.is_online) {
                    <span class="icon is-small">
                      <i class="fa fa-circle circle-grey"></i>
                    </span>
                    }
                  </div>
                  <div class="column is-clearfix pos-relative">
                    <div class="is-pulled-left">
                      <label class="is-size-6">
                        <span
                          class="list-active"
                          title="{{ user.full_name }}"
                          >{{ user.full_name }}</span
                        >
                        @if (user.is_online) {
                        <span class="is-size-7 text-clr-grey">online</span>
                        }
                        <!-- <span class="is-size-7 text-clr-grey" *ngIf="!user.is_online">{{user.last_seen | amTimeAgo}}</span> -->
                      </label>
                      <div class="">
                        @if (!user.isTyping && user.last_message &&
                        !user.file_id) {
                        <span>
                          <label
                            class="chat-msg-text"
                            [ngClass]="{ unReadMsgTxt: user.unread_msg_count }"
                            [innerHTML]="user.last_message | trim | emojismart"
                          ></label>
                        </span>
                        } @if (!user.isTyping && (user.last_message &&
                        user.file_id) || (!user.last_message && user.file_id)) {
                        <span>
                          <label class="chat-msg-text">
                            <i class="fa fa-paperclip" aria-hidden="true"></i>
                            {{ user.file_id }}
                          </label>
                        </span>
                        } @if (user.isTyping) {
                        <span>
                          <label class="chat-msg-text has-text-success">{{
                            user.is_typing_msg
                          }}</label>
                        </span>
                        }
                      </div>
                    </div>
                    <br />
                    @if (!user.is_online) {
                    <span class="is-size-7 text-clr-grey time-ago">{{
                      user.last_seen | amTimeAgo
                    }}</span>
                    } @if (user.unread_msg_count) {
                    <span class="badge-count">{{ user.unread_msg_count }}</span>
                    }
                  </div>
                </div>
                } @if (user?.chat_type == 'user') {
                <div class="chat-close">
                  <i
                    class="fa fa-times"
                    title="Remove Chat"
                    (click)="removeChat(user.chat_id, ind)"
                  ></i>
                </div>
                } @if (user.chat_type == 'group') {
                <div
                  class="columns is-gapless display-flex"
                  [routerLink]="['/chats/groupuser', user.group_id]"
                >
                  <div class="column is-one-quarter group-img">
                    @if (!user.group_icon) {
                    <empty-uname
                      [userName]="user.full_name"
                      [liProfile]="true"
                    ></empty-uname>
                    } @if (user.group_icon) {
                    <img [src]="profileUrl + user.group_icon" class="" />
                    }
                  </div>
                  <div class="column is-clearfix pos-relative">
                    <div class="is-pulled-left">
                      <label class="is-size-6">
                        <span
                          class="list-active"
                          title="{{ user.full_name }}"
                          >{{ user.full_name }}</span
                        >
                        <!-- <br> -->
                        <!-- <span class="is-size-7 text-clr-grey">{{user.last_message}}</span> -->
                        <!-- <span class="is-size-7 text-clr-grey">Group</span> -->
                      </label>
                      <div class="">
                        @if (!user.isTyping && user.last_message &&
                        !user.file_id) {
                        <span>
                          <label
                            class="chat-msg-text"
                            [ngClass]="{ unReadMsgTxt: user.unread_msg_count }"
                            [innerHTML]="user.last_message | trim | emojismart"
                          ></label>
                        </span>
                        } @if (!user.isTyping && (user.last_message &&
                        user.file_id) || (!user.last_message && user.file_id)) {
                        <span>
                          <label class="chat-msg-text">
                            <i class="fa fa-paperclip" aria-hidden="true"></i>
                            {{ user.file_id }}
                          </label>
                        </span>
                        } @if (user.isTyping) {
                        <span>
                          <label class="chat-msg-text has-text-success">{{
                            user.is_typing_msg
                          }}</label>
                        </span>
                        }
                      </div>
                    </div>
                    <div class="group-identify">
                      <i class="pi pi-users" aria-hidden="true"></i>
                    </div>
                    @if (user.unread_msg_count) {
                    <span class="badge-count">{{ user.unread_msg_count }}</span>
                    }
                  </div>
                </div>
                }
              </li>
              }
              <pagination-loader
                [showFetchLoader]="showPaginateSpinner"
              ></pagination-loader>
            </ul>
          </div>
        </div>
        <div class="is-hidden tab-content"></div>
      </div>
    </div>

    <!-- Empty state Image for no chat list -->
    @if (totalRowCount === 0 && activeUrl !== 'newchat') {
    <div class="empty-state">
      <div class="has-text-centered box">
        <img [src]="'../../../../assets/images/chat_empty.png'" />
        <p>
          So nice to meet you, Stay tuned for exciting events heading YOUR way!
        </p>
        <button class="button mar-top15" [routerLink]="['/chats/newchat']">
          <span class="icon">
            <i class="fa fa-plus"></i>
          </span>
          <span> New Conversation</span>
        </button>
      </div>
    </div>
    }
  </div>
  <!--
  <div class="col-md-9 px-0">
    <router-outlet></router-outlet>
  </div> -->
  <div class="col ps-0">
    <router-outlet></router-outlet>
  </div>
</div>

<!-- <div class="modal welcome-window" [ngClass]="{'is-active': showWelcomeWindow}" *ngIf="is_tour_completed">
<div class="modal-background"></div>
<div class="modal-content">
  <div class="box" *ngIf="welcomeWindowName === 'welcome'">
    <div class="columns">
      <div class="column is-12 has-text-centered">
        <img [src]="'../../../../assets/images/welcome_chat.png'">
        <h2>Hi {{loggedUserDeatails?.first_name}}, Welcome to Canstring Class!</h2>
        <h4>Successfully signed up, now let us have a quick tour of the app.</h4>
      </div>
    </div>
    <div class="columns has-text-centered">
      <div class="column is-12">
        <a class="button is-link" (click)="showOnboarding()">Explore Canstring</a>
      </div>
    </div>
  </div>
</div>
<button class="modal-close is-large" (click)="welcomeWindow()" aria-label="close"></button>
</div> -->

<div class="showAssignment">
  <div class="modal" [ngClass]="{ 'is-modal-active': isActiveGroupForm }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <div class="card">
        <form>
          <header class="card-header">
            <p class="card-header-title">New Class Group</p>
            <button
              class="delete"
              aria-label="close"
              (click)="hideGroupWindow()"
            ></button>
          </header>
          <div class="card-content">
            <div class="content">
              <div class="field">
                <label class="label">Group Name</label>
                <div class="control">
                  <input
                    type="text"
                    name="group_title"
                    class="input"
                    placeholder="Enter Group name..."
                  />
                </div>
              </div>

              <div class="columns userList">
                <div class="column">
                  <div
                    class="field pos-relative scrollbar"
                    infinite-scroll
                    [infiniteScrollDistance]="modalScrollDistance"
                    [infiniteScrollThrottle]="modalScrollThrottle"
                    [scrollWindow]="false"
                    (scrolled)="fetchNextUserList()"
                  >
                    <div class="panel">
                      @for (user of userList; track user) {
                      <label
                        class="panel-block pos-relative"
                        (click)="selectedUser(user.user_id)"
                      >
                        <div class="chat-user-status">
                          @if (!user.user_icon) {
                          <empty-uname
                            [userName]="user.first_name"
                            [liProfile]="true"
                          ></empty-uname>
                          } @if (user.user_icon) {
                          <img
                            [src]="profileUrl + user.user_icon"
                            class="image is-48x48"
                          />
                          }
                          <span class="icon is-small">
                            <i
                              class="fa fa-circle"
                              [ngClass]="{
                                'circle-grey': user.user_status === 0,
                                'circle-green': user.user_status === 1,
                                'circle-red': user.user_status === 2,
                                'circle-yellow': user.user_status === 3
                              }"
                            ></i>
                          </span>
                        </div>
                        <div class="mar-0-10">
                          <span class="display-b">
                            {{ user.first_name }} {{ user.last_name }}</span
                          >
                          @if (user.is_online) {
                          <p
                            class="is-size-7"
                            [ngClass]="{
                              'circle-grey': user.user_status === 0,
                              'circle-green': user.user_status === 1,
                              'circle-red': user.user_status === 2,
                              'circle-yellow': user.user_status === 3
                            }"
                          >
                            {{ user.status_name }}
                          </p>
                          } @if (!user.is_online) {
                          <p class="is-size-7 text-clr-grey">
                            {{ user.last_seen | amTimeAgo }}
                          </p>
                          }
                        </div>
                        @if (userIdList.indexOf(user.user_id) > -1) {
                        <span class="icon is-small icon-align is-pulled-right">
                          <i class="fa fa-check"></i>
                        </span>
                        }
                      </label>
                      }

                      <pagination-loader
                        [showFetchLoader]="showPaginateSpinner"
                      ></pagination-loader>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer class="modal-card-foot">
            <button class="button is-info" (click)="createNewGroup()">
              Create
            </button>
            <button class="button" (click)="hideGroupWindow()">Cancel</button>
          </footer>
        </form>
      </div>
    </div>
  </div>
</div>
